import { Button, Grid, Group, TextInput, NumberInput, Select } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useForm } from '@mantine/form';

import { transformDateFilter } from '@/shared/utils/helpers/datetime-format';
import { CustomCollapse, useAppSelector, selectCurrencies } from '@/shared';
import {
  transactionsTypes,
  transactionsTypeTitles,
  transactionsStatuses,
  transactionsStatusTitles,
} from '../utils/const/common';

import type { TGetTransactions } from '../store/types';

type FormData = TGetTransactions;

type Props = {
  onSubmit: (data: TGetTransactions) => void;
  onReset: () => void;
};

export const TransactionsFilter = (props: Props) => {
  const { onSubmit, onReset } = props;
  const avalableCurrencies = useAppSelector(selectCurrencies);

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {},
  });

  const handleSubmit = (values: FormData) => {
    const newValues: TGetTransactions = {
      ...values,
      createdFrom: values.createdFrom ? transformDateFilter(values.createdFrom).dateFrom : undefined,
      createdTo: values.createdTo ? transformDateFilter(values.createdTo).dateTo : undefined,
    };

    onSubmit(newValues);
  };

  const handleReset = () => {
    form.reset();
    onReset();
  };

  return (
    <CustomCollapse title="Фильтр">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Первая секция */}
            <NumberInput
              label="ID транзакции"
              key={form.key('id')}
              {...form.getInputProps('id')}
            />
            <NumberInput
              label="ID магазина"
              key={form.key('shopId')}
              {...form.getInputProps('shopId')}
            />
            <NumberInput
              label="ID платежа"
              key={form.key('paymentId')}
              {...form.getInputProps('paymentId')}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Вторая секция */}
            <Group justify='space-between' grow>
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (от)"
                clearable
                key={form.key('createdFrom')}
                {...form.getInputProps('createdFrom')}
              />
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (до)"
                clearable
                key={form.key('createdTo')}
                {...form.getInputProps('createdTo')}
              />
            </Group>
            <Group justify='space-between' grow>
              <TextInput
                label="Сумма (от)"
                key={form.key('amountFrom')}
                {...form.getInputProps('amountFrom')}
              />
              <TextInput
                label="Сумма (до)"
                key={form.key('amountTo')}
                {...form.getInputProps('amountTo')}
              />
            </Group>
            <Select
              label="Статус"
              clearable
              data={transactionsStatuses.map((status) => ({ value: status, label: transactionsStatusTitles[status] }))}
              key={form.key('status')}
              {...form.getInputProps('status')}
            />
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Третья секция */}
            <Select
              label="Тип транзакции"
              clearable
              data={transactionsTypes.map((item) => ({ value: item, label: transactionsTypeTitles[item] }))}
              key={form.key('type')}
              {...form.getInputProps('type')}
            />
            <Select
              label="Валюта"
              clearable
              data={avalableCurrencies.map((currency) => ({ value: currency, label: currency }))}
              key={form.key('currency')}
              {...form.getInputProps('currency')}
            />
            <Group justify="flex-end" mt="25">
              <Button variant="outline" onClick={handleReset}>
                Сбросить
              </Button>
              <Button type="submit">
                Отправить
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </form>
    </CustomCollapse>
  );
};
